(() => {
  'use strict';
  if (window.dvCartDeliveryInstalled) return;
  window.dvCartDeliveryInstalled = true;
  let generation = 0;
  let lastPostcode = '';
  let lastOpen = false;
  const rootPath = window.Shopify?.routes?.root || '/';
  const invalidate = () => {
    generation++;
    document.querySelectorAll('[data-dv-cart-delivery]').forEach(host => {
      host.querySelector('[data-delivery-rates]').replaceChildren();
      host.querySelector('[data-delivery-status]').textContent = '';
      host.querySelector('[data-delivery-check]').disabled = false;
    });
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      invalidate();
      const host = document.querySelector('[data-dv-cart-delivery]');
      if (!host || !lastPostcode || !lastOpen) return;
      host.open = true;
      host.querySelector('[data-delivery-zip]').value = lastPostcode;
      quote(host);
    });
  }
  const read = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', ...options, signal: AbortSignal.timeout(10000) });
    if (!response.ok) throw new Error('Quote unavailable');
    return response.json();
  };
  const signature = cart => JSON.stringify([cart.total_price, cart.currency, cart.discount_codes, cart.cart_level_discount_applications, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
  document.addEventListener('input', event => {
    const host = event.target.closest?.('[data-dv-cart-delivery]');
    if (!host) return;
    const postcode = host.querySelector('[data-delivery-zip]').value.trim();
    lastPostcode = /^[1-9][0-9]{2}$/.test(postcode) ? postcode : '';
    generation++;
    host.querySelector('[data-delivery-rates]').replaceChildren();
    host.querySelector('[data-delivery-status]').textContent = '';
    host.querySelector('[data-delivery-check]').disabled = false;
  });
  document.addEventListener('toggle', event => {
    if (event.target.isConnected && event.target.matches?.('[data-dv-cart-delivery]')) lastOpen = event.target.open;
  }, true);
  async function quote(host) {
    const button = host.querySelector('[data-delivery-check]');
    if (button.disabled) return;
    const input = host.querySelector('[data-delivery-zip]');
    const status = host.querySelector('[data-delivery-status]');
    const list = host.querySelector('[data-delivery-rates]');
    const copy = JSON.parse(host.querySelector('[data-delivery-copy]').textContent);
    const postcode = input.value.trim();
    list.replaceChildren();
    if (!/^[1-9][0-9]{2}$/.test(postcode)) { status.textContent = copy.invalid; input.focus(); return; }
    lastPostcode = postcode;
    lastOpen = host.open;
    const current = ++generation;
    const active = () => current === generation && host.isConnected;
    button.disabled = true;
    status.textContent = copy.loading;
    try {
      const before = await read(`${rootPath}cart.js`);
      if (!before.item_count || !before.requires_shipping) { if (active()) status.textContent = copy.empty; return; }
      const params = new URLSearchParams({ 'shipping_address[zip]': postcode, 'shipping_address[country]': 'Iceland' });
      await read(`${rootPath}cart/prepare_shipping_rates.json?${params}`, { method: 'POST' });
      let result = null;
      for (let attempt = 0; attempt < 8 && active(); attempt++) {
        result = await read(`${rootPath}cart/async_shipping_rates.json?${params}`);
        if (result !== null) break;
        await new Promise(resolve => setTimeout(resolve, 750));
      }
      if (!active()) return;
      if (!Array.isArray(result?.shipping_rates)) throw new Error('Quote timeout');
      const after = await read(`${rootPath}cart.js`);
      if (!active()) return;
      if (signature(before) !== signature(after)) { status.textContent = copy.changed; return; }
      const valid = result.shipping_rates.filter(rate => typeof rate.name === 'string' && rate.name.trim());
      if (valid.length !== result.shipping_rates.length) throw new Error('Invalid quote');
      // Ajax rates precede shipping discounts. Never present them as payable prices.
      const groups = { pickup: new Set(), home: new Set(), other: new Set() };
      valid.forEach(rate => {
        const name = rate.presentment_name || rate.name;
        const normalized = name.toLocaleLowerCase('is-IS');
        const kind = /heimsend|dagdreif|flytjandi|home delivery/.test(normalized) ? 'home'
          : /dropp|póstbox|postbox|pósthús|afhendingarsta|pickup/.test(normalized) ? 'pickup' : 'other';
        groups[kind].add(name);
      });
      Object.entries(groups).forEach(([kind, names]) => {
        if (!names.size) return;
        const group = document.createElement('details');
        group.className = 'dv-cart-delivery__group';
        const summary = document.createElement('summary');
        summary.textContent = `${copy[kind]} (${names.size})`;
        group.appendChild(summary);
        const options = document.createElement('ul');
        names.forEach(name => {
          const item = document.createElement('li');
          item.textContent = name;
          options.appendChild(item);
        });
        group.appendChild(options);
        list.appendChild(group);
      });
      status.textContent = valid.length ? copy.ready : copy.empty;
    } catch (_) { if (active()) status.textContent = copy.failed; }
    finally { if (active()) button.disabled = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-delivery-check]');
    if (button) quote(button.closest('[data-dv-cart-delivery]'));
  });
})();
